module.exports = __webpack_public_path__ + "static/media/data-science.9f3396f6.png";